export function CloseButton() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
    >
      <circle cx="25" cy="25" r="25" fill="#F8F8F8" />
      <path
        d="M15 35.0002L25 25.0002L15 15.0002"
        stroke="#242424"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35 35.0002L25 25.0002L35 15.0002"
        stroke="#242424"
        stroke-width="4"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ShoppingCart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M10.4065 27.8697C8.83369 27.7921 8.86331 25.6567 10.4064 25.5826C14.7776 25.5972 26.307 25.5865 30.8172 25.5896C32.0508 25.5896 33.1062 24.7792 33.3836 23.6191L35.9446 12.9142C36.0913 12.3013 35.9433 11.6669 35.5387 11.1739C35.134 10.6808 34.5282 10.394 33.8766 10.394C32.0622 10.394 16.6608 10.3267 8.77228 10.2964L7.52181 5.81773C7.22163 4.74745 6.20978 4 5.06111 4H1.05525C0.47247 4 0 4.45606 0 5.0186C0 5.58114 0.47247 6.0372 1.05525 6.0372H5.06111C5.25887 6.0372 5.43298 6.16588 5.48441 6.34903L10.2868 23.5482C9.44243 23.5778 8.65592 23.9093 8.05949 24.4934C7.43282 25.1073 7.09626 25.9199 7.11181 26.7815C7.14291 28.5048 8.62089 29.9068 10.4065 29.9068H11.9452C11.7165 30.3702 11.5881 30.8883 11.5881 31.4348C11.5881 33.4007 13.245 35 15.2816 35C17.3182 35 18.9751 33.4007 18.9751 31.4348C18.9751 30.8882 18.8467 30.3702 18.618 29.9068H25.2812C25.0527 30.3701 24.9243 30.8878 24.9243 31.4342C24.9243 33.4001 26.5813 34.9995 28.6178 34.9995C30.6545 34.9995 32.3114 33.4 32.3114 31.4342C32.3114 30.8666 32.1726 30.3299 31.927 29.853C32.3446 29.7173 32.6457 29.3371 32.6457 28.8883C32.6457 28.3257 32.1733 27.8697 31.5905 27.8697H10.4065ZM16.8646 31.4348C16.8646 32.2774 16.1544 32.9629 15.2815 32.9629C14.4086 32.9629 13.6985 32.2774 13.6985 31.4348C13.6985 30.5927 14.4079 29.9075 15.2802 29.9069H15.2829C16.1551 29.9075 16.8646 30.5927 16.8646 31.4348ZM28.6179 32.9623C27.7451 32.9623 27.0349 32.2768 27.0349 31.4343C27.0349 30.6001 27.7312 29.9202 28.5922 29.9069H28.6437C29.5047 29.9202 30.2011 30.6001 30.2011 31.4343C30.201 32.2768 29.4908 32.9623 28.6179 32.9623ZM33.8843 12.4387C33.8906 12.4463 33.8897 12.4499 33.8883 12.4557L32.8092 16.9664H29.1551L29.7773 12.4151L33.8681 12.431C33.8744 12.4312 33.8781 12.4312 33.8843 12.4387ZM23.005 23.5523V19.0036H26.7478L26.1259 23.5523H23.005ZM17.7723 23.5523L17.1453 19.0036H20.8946V23.5523H17.7723ZM12.9144 23.5523H12.9111C12.6539 23.5522 12.4273 23.3848 12.3604 23.1462L11.2037 19.0036H15.0162L15.6431 23.5523H12.9144ZM16.8645 16.9665L16.2299 12.3625L20.8945 12.3806V16.9665H16.8645ZM23.005 16.9665V12.3888L27.6497 12.4069L27.0263 16.9665H23.005ZM14.0996 12.3541L14.7353 16.9664H10.6349L9.34183 12.3356L14.0996 12.3541ZM30.8172 23.5523H28.2546L28.8765 19.0036H32.3218L31.3272 23.1607C31.2721 23.3913 31.0624 23.5523 30.8172 23.5523Z"
        fill="#6B6B6B"
      />
    </svg>
  );
}

export function SecureShield() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      viewBox="0 0 29 33"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.33263 5.38033C0.978992 5.5086 0.729287 5.82737 0.689919 6.20117C-0.134123 14.0063 2.09991 27.05 14.4826 32.1481C25.8999 27.05 29.1655 15.728 28.16 6.20117C28.1206 5.82737 27.8709 5.5086 27.517 5.38033C27.517 5.38033 23.3414 4.60527 20.7999 3.67495C18.3405 2.77468 14.7607 0.758751 14.7607 0.758751C14.5441 0.680351 14.3065 0.680351 14.0894 0.758751C14.0894 0.758751 10.5095 2.77467 8.04991 3.67495C5.50834 4.60525 1.33263 5.38033 1.33263 5.38033ZM9.90918 19.9105C10.6228 20.6291 11.3361 21.3474 12.0515 22.0628C12.2296 22.2409 12.5137 22.2409 12.687 22.0628L21.5119 13.2475C21.69 13.0742 21.69 12.7901 21.5119 12.612L19.692 10.7921C19.5139 10.6188 19.2298 10.6188 19.0517 10.7921L12.3789 17.4698L9.78388 14.8748C9.61056 14.7015 9.32169 14.7015 9.14837 14.8748L7.33332 16.6898C7.16 16.8631 7.16 17.152 7.33332 17.3253C8.19494 18.1843 9.05225 19.0476 9.90918 19.9105Z"
        fill="#08BF5B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.33263 5.38033C0.978992 5.5086 0.729287 5.82737 0.689919 6.20117C-0.134123 14.0063 2.09991 27.05 14.4826 32.1481C25.8999 27.05 29.1655 15.728 28.16 6.20117C28.1206 5.82737 27.8709 5.5086 27.517 5.38033C27.517 5.38033 23.3414 4.60527 20.7999 3.67495C18.3405 2.77468 14.7607 0.758751 14.7607 0.758751C14.5441 0.680351 14.3065 0.680351 14.0894 0.758751C14.0894 0.758751 10.5095 2.77467 8.04991 3.67495C5.50834 4.60525 1.33263 5.38033 1.33263 5.38033ZM9.90918 19.9105C10.6228 20.6291 11.3361 21.3474 12.0515 22.0628C12.2296 22.2409 12.5137 22.2409 12.687 22.0628L21.5119 13.2475C21.69 13.0742 21.69 12.7901 21.5119 12.612L19.692 10.7921C19.5139 10.6188 19.2298 10.6188 19.0517 10.7921L12.3789 17.4698L9.78388 14.8748C9.61056 14.7015 9.32169 14.7015 9.14837 14.8748L7.33332 16.6898C7.16 16.8631 7.16 17.152 7.33332 17.3253C8.19494 18.1843 9.05225 19.0476 9.90918 19.9105Z"
        fill="#6B6B6B"
      />
    </svg>
  );
}

export function Info() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 25 26"
      fill="none"
    >
      <circle cx="12.5" cy="13" r="11.5" stroke="#6B6B6B" stroke-width="2" />
      <path
        d="M12.0265 5.52014C12.0518 5.50671 12.1654 5.5 12.3674 5.5C12.5821 5.52686 12.721 5.547 12.7841 5.56043C13.2765 5.72158 13.6301 6.03046 13.8447 6.48705C13.9583 6.74221 14.0152 6.99065 14.0152 7.23237C14.0152 7.48753 13.9583 7.73597 13.8447 7.9777C13.6301 8.44772 13.2765 8.76331 12.7841 8.92446C12.6705 8.95132 12.5126 8.96475 12.3106 8.96475C12.096 8.96475 11.9381 8.95132 11.8371 8.92446C11.3321 8.76331 10.9722 8.44772 10.7576 7.9777C10.6566 7.76283 10.6061 7.51439 10.6061 7.23237C10.6061 7.04436 10.6124 6.91007 10.625 6.8295C10.6881 6.58777 10.8018 6.35947 10.9659 6.1446C11.2311 5.80887 11.5846 5.60072 12.0265 5.52014ZM11.8939 10.5158C13.1566 10.4621 13.7626 10.4353 13.7121 10.4353H13.8258V18.0496H15V19.5H14.8295L13.6174 19.4597C12.923 19.4463 12.2033 19.4463 11.4583 19.4597L10.1705 19.5H10V18.0496H11.3068V15.2899C11.3068 13.4233 11.3005 12.4631 11.2879 12.4094C11.2374 12.2482 11.1553 12.1542 11.0417 12.1273C10.8649 12.0736 10.6124 12.0468 10.2841 12.0468H10.0568V10.5964H10.1136L11.8939 10.5158Z"
        fill="#6B6B6B"
      />
    </svg>
  );
}
export function BackButton() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
      >
        <circle cx="25" cy="25" r="25" fill="#F8F8F8" />
        <g filter="url(#filter0_d_29_930)">
          <path
            d="M18.5 25.1365L31.5 38"
            stroke="#232323"
            stroke-width="4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5 24.8635L31.5 12"
            stroke="#232323"
            stroke-width="4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_29_930"
            x="9.5"
            y="4"
            width="31"
            height="44"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_29_930"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_29_930"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
}

export function CreditCard() {
  return <img src="creditcard.svg" height="50px" width="50px" />;
}

export function CreditCardBigButton() {
  return <img src="creditcard.svg" height="100px" width="100px" />;
}

export function CardLogos() {
  return <img src="mastervisa.svg" height="40px" width="160px" />;
}

export function GooglePay() {
  return <img src="googlepay.svg" height="27px" width="50px" />;
}

export function GooglePayBigButton() {
  return <img src="googlepay.svg" height="50px" width="160px" />;
}

export function ApplePay() {
  return <img src="applepay.svg" height="33px" width="50px" />;
}

export function ApplePayBigButton() {
  return <img src="applepay.svg" height="50px" width="160px" />;
}

export function Docomo() {
  return <img src="docomo.svg" width="60px" height="50px" />;
}

export function DocomoBigButton() {
  return <img src="docomo.svg" height="40px" width="160px" />;
}

export function SoftBank() {
  return <img src="softbank.svg" width="50px" height="8px" />;
}

export function SoftBankBigButton() {
  return <img src="softbank.svg" height="40px" width="160px" />;
}

export function Atone() {
  return <img src="atone.svg" width="50px" height="13px" />;
}

export function AtoneBigButton() {
  return <img src="atone.svg" height="40px" width="160px" />;
}

export function AtoneLite() {
  return <img src="assets/openweb/one_time.png" width="50px" />;
}

export function AtoneLiteBigButton() {
  return <img src="assets/openweb/one_time.png" height="100px" width="auto" />;
}

export function PayPay() {
  return <img src="assets/openweb/payment_PayPay.png" width="50px" />;
}

export function PayPayBigButton() {
  return <img src="ico_logo_paypay.svg" height="40px" width="160px" />;
}

export function AuPay() {
  return <img src="assets/openweb/payment_auPay.png" width="50px" />;
}

export function AuPayBigButton() {
  return <img src="au_pay.svg" height="40px" width="160px" />;
}

export function Au() {
  return <img src="au.svg" width="50px" />;
}

export function AuBigButton() {
  return <img src="au.svg" height="70px" width="160px" />;
}

export function Paidy() {
  return <img src="assets/openweb/payment_paidy.png" width="50px" />;
}

export function PaidyBigButton() {
  return (
    <img src="assets/openweb/payment_paidy.png" height="40px" width="160px" />
  );
}

export function Rakuten() {
  return <img src="assets/openweb/payment_rakuten.png" width="50px" />;
}

export function RakutenBigButton() {
  return <img src="rakuten.svg" height="40px" width="160px" />;
}

export function Merpay() {
  return <img src="merpay.svg" width="50px" />;
}

export function MerpayBigButton() {
  return <img src="merpay.svg" height="100px" width="100px" />;
}

export function Warning() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M50.5 25C50.5 38.8071 39.3071 50 25.5 50C11.6929 50 0.5 38.8071 0.5 25C0.5 11.1929 11.6929 0 25.5 0C39.3071 0 50.5 11.1929 50.5 25ZM22.1667 12.5C22.1667 10.1988 24.0321 8.33333 26.3333 8.33333C28.6345 8.33333 30.5 10.1988 30.5 12.5V25.8333C30.5 28.1345 28.6345 30 26.3333 30C24.0321 30 22.1667 28.1345 22.1667 25.8333V12.5ZM26.3333 33.3333C24.0321 33.3333 22.1667 35.1988 22.1667 37.5C22.1667 39.8012 24.0321 41.6667 26.3333 41.6667C28.6345 41.6667 30.5 39.8012 30.5 37.5C30.5 35.1988 28.6345 33.3333 26.3333 33.3333Z"
        fill="#AA1212"
      />
    </svg>
  );
}

export function Shield() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 27 31"
      fill="none"
    >
      <path
        d="M13.3999 30.2C13.3819 30.2 13.3637 30.1996 13.3459 30.1986C13.1458 30.1865 8.40632 29.8603 4.6433 25.4302C0.957564 21.0913 -0.445761 14.4793 0.472921 5.77772C0.509973 5.4259 0.74499 5.12588 1.07782 5.00516L13.0842 0.655439C13.2885 0.581651 13.5121 0.581651 13.716 0.655439L25.722 5.00516C26.055 5.12588 26.29 5.4259 26.3271 5.77772C27.2456 14.4793 25.8424 21.0913 22.1567 25.43C18.3937 29.8601 13.654 30.1865 13.4543 30.1984C13.4359 30.1994 13.4179 30.1998 13.3999 30.1998V30.2ZM2.25735 6.54584C1.51229 14.4387 2.789 20.3876 6.05531 24.2331C9.10269 27.8204 12.8903 28.298 13.3976 28.3469C13.9013 28.2959 17.7403 27.7944 20.7731 24.1991C24.0186 20.3521 25.2854 14.4144 24.5424 6.54563L13.3999 2.50882L2.25735 6.54584Z"
        fill="#6B6B6B"
      />
      <path
        d="M17.5728 13.0871H17.1974V10.2889C17.1974 8.77143 15.9613 7.53711 14.442 7.53711H12.3575C10.8382 7.53711 9.60213 8.77143 9.60213 10.2889V13.0871H9.22716C8.46537 13.0871 7.84247 13.7104 7.84247 14.4726V20.0268C7.84247 20.7888 8.46537 21.4121 9.22716 21.4121H17.5724C18.3335 21.4121 18.9566 20.7888 18.9566 20.0268H18.9571V14.4726C18.9571 13.7104 18.3344 13.0871 17.5728 13.0871ZM13.9785 17.0941V19.2735C13.9785 19.4321 13.8485 19.5621 13.6891 19.5621H13.1102C12.951 19.5621 12.8208 19.4321 12.8208 19.2735V17.0941C12.4751 16.8939 12.2422 16.5211 12.2422 16.0934C12.2422 15.4551 12.7607 14.9371 13.4001 14.9371C14.0395 14.9371 14.5578 15.4551 14.5578 16.0934C14.5576 16.5211 14.3245 16.8937 13.9789 17.0941H13.9785ZM15.3446 13.0871H11.4543V10.2889C11.4543 9.79178 11.8593 9.38711 12.3569 9.38711H14.4414C14.9393 9.38711 15.3446 9.79178 15.3446 10.2889V13.0871Z"
        fill="#6B6B6B"
      />
    </svg>
  );
}
